<template>
    <main class="authentication">
        <div class="hero is-fullheight">
            <div class="hero-body">
                <div class="auth-box">
                    <div class="brand">
                        <img v-if="appinfo('logo.active')" :src="appinfo('logo.url')" width="140" height="30" :alt="appinfo('name')">
                        <span v-else v-text="appinfo('name')"></span>
                    </div>
                    <router-view></router-view>
                </div>
            </div>
            <div class="hero-foot has-text-centered has-text-grey-darker">Developed by <a target="_blank" href="https://www.hevelop.com">Hevelop</a></div>
        </div>
    </main>
</template>

<script>
    export default {
    }
</script>